import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import axios from "axios";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { toast } from "react-toastify";
import Tooltip from "@mui/material/Tooltip";
import AddLinkIcon from "@mui/icons-material/AddLink";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { CheckToken } from "../login/AccessToken";

function LinkingForUploadRepAppointmentPage({ refresh }) {
  const [userData, setUserData] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") ?? ""
  );

  const headers = { Authorization: `Bearer ${authToken}` };
  const history = useHistory();
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(() => {
    if (Token()) {
      getUploadData();
    }
  }, [refresh]);

  const getUploadData = () => {
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_data_upload_status/`,
        {},
        {
          headers: headers,
        }
      )
      .then((res) => {
        // if (
        //   res.data.detail === "Authentication credentials were not provided."
        // ) {
        if (res.data.status === "Success") {
          setUserData(res.data?.data);
        }
        // if (res.data?.data)
        else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
      });
  };

  const getRowClassName = (params) => {
    return "custom-row";
  };
  const linkToAbdm = (row) => {
    console.log("Link to ABDM for:", row);

    const formData = new FormData();
    formData.append("patient_id", row.patient_id);
    formData.append("careContextReferenceID", row.care_context);

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}save_pending_care_context_linking/`,
        formData,
        {
          headers: {
            ...headers,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        console.log("Response data:", response.data);

        var post_data = {};
        post_data.query = {};

        post_data.query.id = row.abha_id;
        post_data.query.purpose = "KYC_AND_LINK";
        post_data.query.requester = {
          type: "HIP",
          id: sessionStorage.getItem("facility_name"),
        };
        post_data.query.authMode = "DEMOGRAPHICS";

        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}auth_init_workflow/`,
            JSON.stringify(post_data),
            {
              headers: headers,
            }
          )
          .then((res) => {
            console.log("AUth Init WorkFlow Result", res.data);
            if (res.data.status !== "" && res.data.status === "Success") {
              var post_data1 = {};
              post_data1.credential = {};

              post_data1.transactionId = res.data.transaction_id;
              post_data1.credential.demographic = {};
              post_data1.credential.demographic.name = row.patient_name;
              post_data1.credential.demographic.gender = row.gender;
              const formatDateOfBirth = (year, month, day) => {
                const formattedMonth = month < 10 ? `0${month}` : month;
                const formattedDay = day < 10 ? `0${day}` : day;
                return `${year}-${formattedDay}-${formattedMonth}`;
              };

              post_data1.credential.demographic.dateOfBirth = formatDateOfBirth(
                row.year_of_birth,
                row.month_of_birth,
                row.day_of_birth
              );

              post_data1.credential.demographic.authCode = "";
              // console.log(post_data1)
              axios
                .post(
                  `${REACT_APP_BACKEND_ROUTE_URL}auth_confirm_workflow/`,
                  JSON.stringify(post_data1),
                  {
                    headers: headers,
                  }
                )
                .then((res1) => {
                  console.log("Confirm Auth Result", res1.data);
                  if (
                    res1.data.status !== "" &&
                    res1.data.status === "Success"
                  ) {
                    console.log("inside if");
                    var post_data2 = {};
                    post_data2.link = {};
                    post_data2.link.accessToken = res1.data.access_token;
                    post_data2.link.patient = {};
                    post_data2.link.patient.referenceNumber = row.patient_id;
                    post_data2.link.patient.display = row.abha_id;
                    post_data2.link.patient.careContexts = [];
                    var careContextData = {};
                    careContextData.display = row.display;
                    careContextData.referenceNumber = row.care_context;
                    post_data2.link.patient.careContexts[0] = careContextData;
                    post_data2.pending_care_context_transaction_id =
                      response.data.pending_care_context_transaction_id;

                    // setCompleteVisit(true);

                    axios
                      .post(
                        `${REACT_APP_BACKEND_ROUTE_URL}add_context_workflow/`,
                        JSON.stringify(post_data2),
                        {
                          headers: headers,
                        }
                      )
                      .then((res) => {
                        console.log("Add Visit Purpose", res.data);
                        if (res.data.status !== "") {
                          console.log(res);
                          if (res.data.status === "Success") {
                            toast.success("Care Context Linked");
                          }

                          // toast.success(
                          //   `Visit Purpose ID: ${res.data.reference_number}`
                          // );
                          // get_care_contexts();
                          // setValue3("visit_details", "");
                          // AddCareContextCloseModal();
                          getUploadData();
                        }
                        //ChangeCursor();
                      })
                      .catch((err) => {
                        console.log(err);
                        toast.error(err);
                        //ChangeCursor();
                      });
                  } else {
                    toast.error("some error occurred");
                  }
                })
                .catch((err) => {
                  console.log(err);
                  toast.error(err);
                  //ChangeCursor();
                });
            } else {
              toast.error("some error occurred");
            }
          })
          .catch((err) => {
            console.log(err);
            toast.error(err);
            //ChangeCursor();
          });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  const sortedUserData = [...userData].sort(
    (a, b) => new Date(b.upload_time) - new Date(a.upload_time)
  );

  return (
    <div className="upload-report-table">
      <div>
        {/* <h1 style={{ margin: "auto",textAlign:"center" }}>Upload Status</h1> */}

        <div
          className="data-grid-container"
          style={{ height: "400px", overflowY: "auto" }}
        >
          {userData.length > 0 ? (
            <DataGrid
              rows={sortedUserData}
              columns={[
                {
                  field: "care_context",
                  headerName: "Care Context",
                  width: 150,
                },
                { field: "hi_type", headerName: "HI Type", width: 150 },
                {
                  field: "structure_type",
                  headerName: "Structure Type",
                  width: 150,
                },
                { field: "status", headerName: "Status", width: 150 },
                {
                  field: "upload_time",
                  headerName: "Upload Time",
                  width: 200,
                  valueFormatter: (params) =>
                    new Date(params.value).toDateString() +
                    " " +
                    new Date(params.value).toLocaleTimeString(),
                },
                {
                  field: "abdm_linked",
                  headerName: "ABDM Linking Status",
                  width: 150,
                  renderCell: (params) => (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      {params.row.abdm_linked ? (
                        <CheckIcon style={{ color: "green" }} />
                      ) : (
                        <CloseIcon style={{ color: "red" }} />
                      )}
                    </div>
                  ),
                },
                {
                  field: "linkToAbdm",
                  headerName: "Link to ABDM",
                  width: 150,
                  renderCell: (params) =>
                    params.row.abdm_linked === false ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Tooltip title="Link">
                          <AddLinkIcon
                            style={{ cursor: "pointer", fontSize: "30px" }}
                            onClick={() => linkToAbdm(params.row)}
                          />
                        </Tooltip>
                      </div>
                    ) : null,
                },
              ]}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
              }}
              pageSizeOptions={[5, 10]}
              getRowId={(row) => row.patient_id + row.upload_time}
              components={{
                Toolbar: () => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <GridToolbarColumnsButton />
                      <GridToolbarFilterButton />
                      <GridToolbarDensitySelector />
                    </div>
                  </div>
                ),
              }}
              getRowClassName={getRowClassName}
              sx={{
                "& .MuiDataGrid-root": {
                  border: "1px solid #e0e0e0",
                  borderRadius: "4px",
                  fontFamily: "Arial, sans-serif",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#125386",
                  color: "white",
                  fontSize: "13px",
                  fontWeight: "600",
                  minHeight: "48px !important",
                  "& .MuiDataGrid-columnHeaderTitle": {
                    color: "white",
                    fontWeight: "600",
                    fontSize: "13px",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                    padding: "0 12px",
                  },
                  "& .MuiDataGrid-columnHeader:last-child": {
                    borderRight: "none",
                  },
                  "& .MuiDataGrid-iconButtonContainer": {
                    color: "white",
                  },
                  "& .MuiDataGrid-menuIcon": {
                    color: "white",
                  },
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                  "& .MuiDataGrid-columnHeaderSortable": {
                    "& .MuiDataGrid-sortIcon": {
                      color: "white",
                    },
                  },
                  "& .MuiDataGrid-columnHeaderTitleContainer": {
                    "& .MuiDataGrid-sortIcon": {
                      color: "white !important",
                    },
                  },
                  "& .MuiSvgIcon-root": {
                    color: "white",
                  },
                },
                "& .MuiDataGrid-row": {
                  backgroundColor: "white",
                  minHeight: "40px !important",
                  "&:nth-of-type(even)": {
                    backgroundColor: "white",
                  },
                  "&:hover": {
                    backgroundColor: "#f8f9fa",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#e3f2fd",
                    "&:hover": {
                      backgroundColor: "#e3f2fd",
                    },
                  },
                  borderBottom: "1px solid #e0e0e0",
                },
                "& .MuiDataGrid-cell": {
                  borderRight: "1px solid #e0e0e0",
                  fontSize: "12px",
                  color: "#374151",
                  padding: "8px 12px",
                  minHeight: "40px !important",
                  "&:last-child": {
                    borderRight: "none",
                  },
                  "&:focus": {
                    outline: "none",
                  },
                },
                "& .MuiDataGrid-cellContent": {
                  fontSize: "12px",
                  color: "#374151",
                  fontWeight: "400",
                },
                "& .MuiDataGrid-footerContainer": {
                  backgroundColor: "#f8f9fa",
                  borderTop: "1px solid #e0e0e0",
                  minHeight: "52px",
                },
                "& .MuiTablePagination-root": {
                  color: "#374151",
                  fontSize: "12px",
                },
                "& .MuiDataGrid-toolbarContainer": {
                  backgroundColor: "#f8f9fa",
                  borderBottom: "1px solid #e0e0e0",
                  padding: "8px 16px",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  color: "white !important", // 👈 this overrides black
                },
              }}
            />
          ) : (
            <h3 className="no-report">No Report found</h3>
          )}
        </div>
      </div>
    </div>
  );
}

export default LinkingForUploadRepAppointmentPage;
